import $DB from '../../util/debounce'
// eslint-disable-next-line no-unused-vars
import md5 from 'js-md5'
export default {
  data() {
    return {
      user: {
        mobile: '',
        password: '',
      },
      codeTxt: '获取验证码',
      sending: true,
      second: 60,
      disabled: false,
      pink: false,
    }
  },
  methods: {
    //忘记密码
    goForget() {
      this.$router.push('/forget')
    },
    //自动登录
    changePink() {
      this.pink = !this.pink
    },
    //去登陆
    goRegister() {
      this.$router.push('/register')
    },
    //获取验证码
    getCode: $DB(function () {
      if (!this.sending) return
      if (!this.user.mobile.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      this.$axios
        .post('/api/login/tel_code', {
          phone: this.user.mobile,
        })
        .then((res) => {
          this.sending = false
          this.disabled = true
          if (res.data.code == 0) {
            this.timeDown()
          }
          this.$message(res.data.msg)
        })
    }),
    timeDown() {
      let result = setInterval(() => {
        --this.second
        this.codeTxt = this.second + 'S'
        if (this.second < 0) {
          clearInterval(result)
          this.sending = true
          this.disabled = false
          this.second = 60
          this.codeTxt = '获取验证码'
        }
      }, 1000)
    },
    //登录
    // eslint-disable-next-line no-dupe-keys
    goLogin: $DB(function () {
      if (!this.user.mobile.match(/^(0|86|17951)?1[3456789]\d{9}$/)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      if (!this.user.password) {
        this.$message.error('请输入密码')
        return
      }
      this.$axios
        .post('/api/login/login', {
          mobile: this.user.mobile,
          password: this.user.password,
        })
        .then((res) => {
          if (res.data.code === 0) {
            localStorage.setItem('incredible-k', res.data.data.token)
            this.$router.push('/')
          } else {
            this.$message.error(res.data.msg)
          }
        })
    }),
  },
}
